import moment from 'moment';

export function changeDateFormat(
	currentFormat: string,
	targetFormat: string,
	date?: Date | string | null,
): string | null {
	if (!date) return null;

	if (moment(date, currentFormat, true).isValid()) {
		return moment(date, currentFormat).format(targetFormat);
	} else {
		return null;
	}
}
